
import { waybillMap, timeZone } from '@/utils/const'

export default {
  name: 'LocalCardPC',
  props: {
    route: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    hasDash: {
      type: Boolean,
      default: false,
    },
    isLocalQuery: {
      type: Boolean,
      default: false,
    },
    isLocalTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeZoneOptions: timeZone,
    }
  },
  computed: {
    showFlow() {
      if (typeof window === 'undefined') return true
      return window.localWaybillFlowDisplaySwitch !== false
    },
  },
  methods: {
    getGroupedNodes(list) {
      if (!list || !list.length) return []
      // 按时间倒序排序（最新的在最上面）
      const sorted = [...list].sort((a, b) => {
        const timeA = (a.barScanDt || '') + ' ' + (a.barScanTm || '')
        const timeB = (b.barScanDt || '') + ' ' + (b.barScanTm || '')
        return timeB.localeCompare(timeA)
      })
      const result = []
      let lastDate = ''
      sorted.forEach((item, idx) => {
        const currentDate = item.barScanDt
        if (currentDate !== lastDate) {
          result.push(
            { type: 'date', value: currentDate },
            { type: 'node', data: item, index: idx, isLast: idx === sorted.length - 1 }
          )
          lastDate = currentDate
        } else {
          result.push({ type: 'node', data: item, index: idx, isLast: idx === sorted.length - 1 })
        }
      })
      return result
    },
    getSvgName(name) {
      const names = [
        'collect',
        'delivered',
        'delivery',
        'express-direction',
        'invalid',
        'landing',
        'other',
        'packaged',
        'pickedup',
        'picking',
        'received',
        'signed',
        'take_off',
      ]
      return names.includes(name) ? name : 'other'
    },
    clickFold(index) {
      this.$emit('toggle', index)
    },
    getCurTimeZoneLabel(timeZone) {
      if (!timeZone) return ''
      const o = this.timeZoneOptions.find((item) => item.value === timeZone)
      return o?.label || ''
    },
    getCurStatusTypeI18n(arrList) {
      if (!arrList || arrList.length === 0) return 'awaiting_pickup'
      const priorities = [
        'signed',
        'invalid',
        'delivery',
        'collect',
        'pickedup',
      ]
      for (const p of priorities) {
        if (arrList.some((item) => item.opCodeStatus === p))
          return p === 'signed'
            ? 'signed'
            : p === 'invalid'
            ? 'invalid'
            : 'other'
      }
      return 'other'
    },
    getCurStatusI18n(curItem) {
      const matched = waybillMap.find(
        (item) => item.valueKey === curItem.opCodeStatus
      )
      if (!matched) {
        return 'serviceSupport.querySupport.waybills.opCode_other'
      }
      return matched?.il8nName
    },
    isSigned(route) {
      return this._barState?.hasSigned || false
    },
    getFinalTime(route) {
      const signedItem = this._barState?.signedItem
      if (signedItem) {
        return signedItem.barScanDt + ' ' + signedItem.barScanTm
      }
      return route?.pisDeliveryTm?.queryPromise || ''
    },
    // 预排序 barNewList，避免多处重复排序
    _sortedBars() {
      const list = this.route?.barNewList || []
      return [...list].sort((a, b) => {
        const timeA = (a.barScanDt || '') + ' ' + (a.barScanTm || '')
        const timeB = (b.barScanDt || '') + ' ' + (b.barScanTm || '')
        return timeB.localeCompare(timeA)
      })
    },
    _barState() {
      const bars = this._sortedBars
      const hasSigned = bars.some(item => item.opCodeStatus === 'signed')
      const signedItem = bars.find(item => item.opCodeStatus === 'signed') || null
      return { hasSigned, signedItem }
    },
  },
}
